import React, { useMemo, useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'

import Icon from 'components/Icon'
import SignIn from './components/SignIn'
import Forgot from './components/Forgot'
import ConfirmSignUp from './components/ConfirmSignUp'
import ConfirmRecover from './components/ConfirmRecover'
import useApi from 'hooks/useApi'
import messages from "./messages";

const UserSignIn = ({ history, location }) => {
  const [data, loading, errors, refetch, meta] = useApi()

  const redirectTo = useMemo(() => {
    const target = new URLSearchParams(location.search || '').get('redirect')

    return target === '/' ? null : target
  })

  useEffect(() => {
    if (!data) {
      return;
    }
    if (data.hasOwnProperty('success') && !data.success) {
      return;
    }
    if (meta && meta.redirect) {
      window.location = meta.redirect
    } else if (meta && meta.jwt && redirectTo) {
      window.location = `${redirectTo}&jwt=${meta.jwt}`
    } else if (data.usergroup === "4") {
      history.push('/home')
    } else {
      window.location = '/dashboard'
    }
  }, [data, loading, meta])

  const brand = useMemo(() => {
    if (window.location.hostname.includes('voicetome')) {
      return {
        logo: 'https://voicetome-branding.s3.eu-central-1.amazonaws.com/logo-black-orange.png',
        name: 'VoiceToMe',
        url: 'https://voicetome.com/',
      }
    }

    return {
        logo: 'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/small-curve-blue.svg',
        name: 'VoiceArchive',
        url: 'https://www.voicearchive.com/',
    }
  })

  const on = (action, event) => {
    event.preventDefault()

    refetch({
      method: 'POST',
      url: `/user/${action}`,
      body: new FormData(event.target),
    })
  }

  return (
    <div>
      <div className="p-4 absolute w-full space-y-6">
        { !!errors.length &&
          <div className="flex rounded-md bg-red-50 p-4">
            <div className="flex">
              <div className="shrink-0 text-red-800">
                <Icon icon="times" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">
                  <FormattedMessage {...messages.error}/>
                </h3>
                <div className="mt-2 text-sm text-red-700">
                  <ul className="list-disc pl-1 space-y-1">
                    { errors.map((error) => (
                      <li>
                        { error }
                      </li>
                    )) }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        }

        { redirectTo &&
          <div className="flex rounded-md bg-blue-50 p-4">
            <div className="shrink-0 text-blue-400">
              <Icon icon="info" />
            </div>
            <div className="ml-3 flex-1 md:flex md:justify-between">
              <p className="text-sm text-blue-700">
                <FormattedMessage {...messages.redirectedTo1}/> <u className="underline">{ redirectTo }</u> <FormattedMessage {...messages.redirectedTo2}/>
              </p>
              <p className="mt-3 text-sm md:mt-0 md:ml-6">
                <a href={redirectTo} className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600">Go now <span aria-hidden="true">&rarr;</span></a>
              </p>
            </div>
          </div>
        }
      </div>

      <Switch>
        <Route path="/user/sign-up/confirm/:token">
          <ConfirmSignUp {...brand} onSubmit={(event) => on('confirm', event)} loading={loading} result={meta} />
        </Route>

        <Route path="/user/sign-in">
          <SignIn {...brand} onSubmit={(event) => on('authenticate', event)} loading={loading} />
        </Route>

        <Route path="/user/forgot/confirm/:token">
          <ConfirmRecover {...brand} onSubmit={(event) => on('confirm', event)} loading={loading} />
        </Route>

        <Route path="/user/forgot">
          <Forgot {...brand} onSubmit={(event) => on('recover', event)} loading={loading} result={meta} />
        </Route>
      </Switch>
    </div>
  )
}

export default UserSignIn
